import { API, standardResponse } from "./middleware";

export async function searchRoles(dataSearch) {
  return API.post("api/roles/searchRoles", dataSearch)
    .then((response) => response.data)
    .catch((error) => standardResponse(false, error.response?.data));
}

export async function getRoles() {
  return API.get("/api/roles/list")
    .then((response) => standardResponse(true, response))
    .catch((error) => standardResponse(false, error.response?.data));
}

export async function createRole(role) {
  const url = `/api/roles/add`;
  return API.post(url, role)
    .then((response) => standardResponse(true, response))
    .catch((error) =>
      // eslint-disable-next-line no-console
      console.error("error", error)
    );
}

export async function updateRole(role) {
  const url = `/api/roles/update`;

  return API.post(url, role)
    .then((response) => standardResponse(true, response))
    .catch((error) => standardResponse(false, error.response?.data));
}

export async function deleteRole(id) {
  const url = `/api/roles/delete?id=${id}`;

  return API.get(url)
    .then((response) => standardResponse(true, response))
    .catch((error) => standardResponse(false, error.response?.data));
}

export async function lockRole(id) {
  const url = `/api/roles/lock?id=${id}`;

  return API.get(url)
    .then((response) => standardResponse(true, response))
    .catch((error) => standardResponse(false, error.response?.data));
}

export async function getRolesByPartnerId(partnerId) {
  const url = `/api/roles/getRolesByPartnerId?partnerId=${partnerId}`;

  return API.get(url)
    .then((response) => response.data)
    .catch((error) => standardResponse(false, error.response?.data));
}

export async function loadSelectRole(mode) {
  const url = `/api/roles/loadSelect?mode=${mode}`;

  return API.get(url)
    .then((response) => response.data)
    .catch((error) => standardResponse(false, error.response?.data));
}

export async function checkRoleToDelete(roleId) {
  const url = `/api/roles/checkDelete?roleId=${roleId}`;

  return API.get(url)
    .then((response) => response.data)
    .catch((error) => standardResponse(false, error.response?.data));
}
